/**
 * CostBackgroundManager — Phase 179.
 *
 * Applies the Culinex COST kitchen backdrop as a fixed background whenever
 * the current route belongs to one of the COST-layer pages. Toggles a
 * `data-cx-cost-bg="1"` attribute on <body> so the styling lives entirely
 * in `index.css` and can be tuned without a React re-render.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const COST_ROUTES = [
  "/prep-recipes", "/recipes", "/menu-studio", "/menu-engineering",
  "/nutrition-ledger", "/cost-simulator", "/food-trials",
];

export default function CostBackgroundManager() {
  const loc = useLocation();
  useEffect(() => {
    const active = COST_ROUTES.some((p) => loc.pathname === p || loc.pathname.startsWith(p + "/"));
    if (active) document.body.setAttribute("data-cx-cost-bg", "1");
    else document.body.removeAttribute("data-cx-cost-bg");
    return () => document.body.removeAttribute("data-cx-cost-bg");
  }, [loc.pathname]);
  return null;
}
